import { useFieldArray } from 'react-hook-form'
import { FC, useState } from 'react'
import { Button, Collapse, Stack } from '@mui/material'
import { FilterCriteriaRow } from './FilterCriteriaRow'
import AddIcon from '@mui/icons-material/Add'
import { useTranslation } from 'react-i18next'

export interface FilterCriteriaProps {
  name: string
  label?: string
  entityTypeId?: number
  transitionTimeout?: number
  maxCriteria?: number
}

const defaultTransitionTimeout = 250
const defaultMaxCriteria = 20

export const FilterCriteria: FC<FilterCriteriaProps> = ({
  name,
  label,
  entityTypeId,
  transitionTimeout = defaultTransitionTimeout,
  maxCriteria = defaultMaxCriteria,
}) => {
  const { t } = useTranslation()
  const { fields, append, remove } = useFieldArray({ name })

  const [removing, setRemoving] = useState<number>()

  const handleAdd = () => {
    append({ dtype: 'F', operand1: null, operator: '', operand2Value: '' })
  }

  const handleRemove = (index: number) => () => {
    setRemoving(index)
    setTimeout(() => {
      remove(index)
      setRemoving(undefined)
    }, transitionTimeout)
  }

  return (
    <Stack spacing={1} sx={{ pt: 2 }}>
      {fields.map((field, index) => (
        <Collapse
          in={index !== removing}
          timeout={transitionTimeout}
          key={field.id}
          unmountOnExit
          appear
        >
          <FilterCriteriaRow
            name={`${name}.${index}`}
            entityTypeId={entityTypeId}
            onRemove={handleRemove(index)}
          />
        </Collapse>
      ))}
      {fields.length < maxCriteria && (
        <Stack direction="row">
          <Button
            size="large"
            variant="outlined"
            color="secondary"
            startIcon={<AddIcon />}
            onClick={handleAdd}
          >
            {label ?? t('criteria')}
          </Button>
        </Stack>
      )}
    </Stack>
  )
}
